module.exports = __webpack_public_path__ + "static/primordial-jade-cutter-a82556cbef30eeacbda6ec8df2a85f8a.png";